import { Grid, styled } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { colors } from "@zapalacorp/tokens";

import { Button } from "../../Form";

export const useStyles = () =>
  makeStyles(() => ({
    panel: {
      border: "1px solid #E4E7EC !important",
      borderRadius: "8px !important",
      backgroundColor: "#F9FAFB !important",
      "& header": {
        backgroundColor: "#F9FAFB !important",
      },
      "& header > span": {
        width: "100% !important",
      },
    },
  }));

export const HeaderWrapper = styled("div")(() => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  width: "100%",

  "@media screen and (max-width: 478px)": {
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "center",
    gap: 8,
  },
}));

export const HeaderTitle = styled("div")(() => ({
  display: "flex",
  alignItems: "flex-start",
  flexDirection: "column",
  "& > div": {
    display: "flex",
    alignItems: "center",
  },
}));

type TitleProps = {
  hasError?: boolean;
};
export const Title = styled("span")(({ hasError }: TitleProps) => ({
  fontFamily: "Manrope",
  fontSize: "16px",
  fontWeight: 600,
  lineHeight: "24px",
  textAlign: "left",
  color: hasError ? colors.error500 : colors.gray600,
}));

export const CountBadge = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center",
  width: "16px",
  height: "16px",
  borderRadius: "100px",
  backgroundColor: colors.gray600,
  marginLeft: "6px",
  "& span": {
    fontFamily: "Manrope",
    fontSize: "11px",
    fontWeight: 600,
    lineHeight: "16px",
    color: "#fff",
  },
}));

export const MainContainer = styled(Grid)(() => ({
  marginTop: "20px",
}));

export const CollapseBody = styled("div")(() => ({}));

export const ButtonSection = styled(Grid)(() => ({
  borderTop: "1px solid #E4E7EC",
  height: "Hug (73px)",
}));

export const AddContainerButton = styled(Button)(() => ({
  color: colors.brandBlue500,
  "& svg": {
    color: colors.brandBlue500,
  },
  "&:focus": {
    backgroundColor: "#0055A414",
    color: colors.brandBlue500,
  },
  "&:hover": {
    backgroundColor: "#0055A414",
    color: colors.brandBlue500,
  },
}));

export const Summary = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
  border: `1px solid ${colors.gray200}`,
  borderRadius: "8px",
  height: "Hug (44px)",
  "& div": {
    display: "flex",
    flexDirection: "column",
    padding: "4px 12px 4px 12px",
    "&:not(:last-child)": {
      borderRight: `1px solid ${colors.gray200}`,
    },
  },
}));

export const Row = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
}));

export const Divider = styled("span")(() => ({
  "&:not(:last-child)": {
    marginBottom: "16px",
    width: "100%",
    border: "1px solid #E4E7EC",
  },
}));

export const ContainerSummaryTitleTypo = styled("span")(() => ({
  fontSize: "10px",
  fontWeight: 700,
  lineHeight: "15px",
  color: colors.gray500,
  letterSpacing: "0.5px",
  textTransform: "uppercase",
}));

export const ContainerSummarySubtitleTypo = styled("span")(() => ({
  fontFamily: "Manrope",
  fontSize: "14px",
  fontWeight: 400,
  color: colors.gray500,
  lineHeight: "20px",
  letterSpacing: "0.25px",
}));

export const ContainerGridHeaderTypo = styled("p")(() => ({
  fontFamily: "Manrope",
  fontSize: "10px",
  fontWeight: 700,
  color: colors.gray800,
  lineHeight: "15px",
  letterSpacing: "0.5px",
  textTransform: "uppercase",
}));
